import { render } from "./GroupWilayahList.vue?vue&type=template&id=0a71c305&scoped=true"
import script from "./GroupWilayahList.vue?vue&type=script&lang=js"
export * from "./GroupWilayahList.vue?vue&type=script&lang=js"

import "./GroupWilayahList.vue?vue&type=style&index=0&id=0a71c305&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-0a71c305"

export default script